module.exports = __webpack_public_path__ + "img/1.00900229.png";